<template>
    <div style="width: 100%;">
        <GMapMap
            :center="{lat: 43.213300, lng: 13.280415}"
            :zoom="10"
            :style="{ width: '100%', height: mapHeight }"
            @center_changed="actualCenter = $event"
        >
            <GMapMarker
                :key="'home-' + index"
                v-for="(marker, index) in markers"
                :position="marker.position"
                :icon="$image('map-pin-home.svg')"
                :clickable="true"
            />

            <GMapMarker
                :key="'place-' + (placeMarker.place?._id || index) + '-' + (placeMarker.type || 'none')"
                v-for="(placeMarker, index) in placeMarkers"
                :position="placeMarker.place.position"
                :icon="placeMarker.icon"
                :clickable="true"
                @click="$emit('select', { place: placeMarker.place, type: placeMarker.type })"
                :draggable="draggable"
                @dragend="onDragend"
            />

            <GMapMarker
                :key="'info-' + (info?._id || index)"
                v-for="(info, index) in infos"
                :position="info.position"
                :icon="$image('map-pin-operation.svg')"
                :clickable="true"
                @click="$emit('selectInfo', info)"
            />
        </GMapMap>
    </div>
</template>

<script>
export default {
    props: {
        places: Array,
        infos: Array,
        selected: Array,
        draggable: Boolean,
        itemsData: Array,
        mapHeight: {
            type: String,
            default: 'calc(100vh - 189px)'
        }
    },

    data() {
        return {
            markers: [
                {
                    position: {lat: 43.2132992, lng: 13.2806081}
                }
            ],
            defaultCenter: {lat: 43.213300, lng: 13.280415},
            actualCenter: null
        }
    },

    computed: {
        placeMarkers() {
            return (this.places || []).map(place => {
                const type = this.getMarkerType(place)
                return {
                    place,
                    type,
                    icon: this.getMarkerIcon(place, type)
                }
            })
        }
    },

    methods: {
        getMarkerUrlByType(type) {
            if (type === 'operation') {
                return this.$image('map-pin-operation.svg')
            }

            if (type === 'call') {
                return this.$image('map-pin-place.svg')
            }

            if (type === 'expire') {
                return this.$image('map-pin-deadline.svg')
            }

            return this.$image('map-pin-place.svg')
        },

        getMarkerType(place) {
            const itemsAtPlace = (this.itemsData || []).filter(item => {
                const itemPlace = item.place || item.place_occupant
                return itemPlace && itemPlace._id === place._id
            })

            if (itemsAtPlace.some(item => item.type === 'operation')) {
                return 'operation'
            }

            if (itemsAtPlace.some(item => item.type === 'call')) {
                return 'call'
            }

            if (itemsAtPlace.some(item => item.type === 'expire')) {
                return 'expire'
            }

            return null
        },

        check(place_id) {
            if (this.selected) {
                return this.selected.find(s => {
                    const itemPlace = s.place || s.place_occupant
                    return itemPlace && itemPlace._id === place_id
                })
            } else {
                return false
            }
        },

        getMarkerIcon(place, markerType = null) {
            const type = markerType || this.getMarkerType(place)
            const isSelected = !!this.check(place._id)
            const url = this.getMarkerUrlByType(type)

            const googleSize = window?.google?.maps?.Size
            if (!googleSize) {
                return url
            }

            const width = isSelected ? 42 : 30
            const height = isSelected ? 42 : 30

            return {
                url,
                scaledSize: new googleSize(width, height)
            }
        },

        onDragend(event) {
            const result = {
                lat: event.latLng.lat(),
                lng: event.latLng.lng()
            }
            this.$emit('dragend', result)
        },

        getActualCenter() {
            if (this.actualCenter) {
                return {lat: this.actualCenter.lat(), lng: this.actualCenter.lng()}
            } else {
                return {lat: this.defaultCenter.lat, lng: this.defaultCenter.lng}
            }
        }
    },

    mounted() {

    }
}
</script>